import { FC, useState } from 'react';
import { IconButton, Popover, Box, Typography, Switch, FormControlLabel, Tooltip } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import { useSearchFilterNotesStore } from '@/stores/searchFilterNotesStore';

const ListViewControls: FC = () => {
  const { listViewPreferences, setListViewPreferences } = useSearchFilterNotesStore();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isOpen = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="List display options">
        <IconButton
          size="small"
          onClick={handleOpen}
          aria-label="List display options"
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            height: 36,
            width: 36,
          }}
        >
          <TuneIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ mt: 1 }}
      >
        <Box sx={{ p: 2, minWidth: 200 }}>
          <Typography variant="body2" fontWeight={500} sx={{ mb: 1 }}>
            Display options
          </Typography>
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={listViewPreferences.showThumbnails}
                onChange={(e) => setListViewPreferences({ showThumbnails: e.target.checked })}
              />
            }
            label={<Typography variant="body2">Show thumbnails</Typography>}
            sx={{ display: 'flex', ml: 0 }}
          />
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={listViewPreferences.showTags}
                onChange={(e) => setListViewPreferences({ showTags: e.target.checked })}
              />
            }
            label={<Typography variant="body2">Show tags</Typography>}
            sx={{ display: 'flex', ml: 0 }}
          />
        </Box>
      </Popover>
    </>
  );
};

export default ListViewControls;
